import React, { useEffect } from "react";
import { api } from "@/lib/api";
import { getCookieConsent } from "@/components/CookieConsent";

function loadGA4(measurementId) {
  if (window.__levami_ga4_loaded || !measurementId) return;
  window.__levami_ga4_loaded = true;
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(script);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", measurementId);
}

function loadMetaPixel(pixelId) {
  if (window.__levami_pixel_loaded || !pixelId) return;
  window.__levami_pixel_loaded = true;
  /* eslint-disable */
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n; n.loaded = !0; n.version = "2.0"; n.queue = [];
    t = b.createElement(e); t.async = !0; t.src = v;
    s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
  })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
  window.fbq("init", pixelId);
  window.fbq("track", "PageView");
  /* eslint-enable */
}

/**
 * Loads GA4 / Meta Pixel ONLY after explicit cookie consent (analytics/marketing),
 * and only if the corresponding IDs have been configured by the admin in R\u00e9glages > SEO.
 * This component renders nothing.
 */
export default function Analytics() {
  useEffect(() => {
    let settings = null;

    const tryLoad = () => {
      const consent = getCookieConsent();
      if (!consent || !settings) return;
      if (consent.analytics && settings.ga4_measurement_id) loadGA4(settings.ga4_measurement_id);
      if (consent.marketing && settings.meta_pixel_id) loadMetaPixel(settings.meta_pixel_id);
    };

    api.get("/content/seo_settings").then((res) => {
      settings = res.data?.data || {};
      tryLoad();
    }).catch(() => {});

    const handler = () => tryLoad();
    window.addEventListener("levami-consent-updated", handler);
    return () => window.removeEventListener("levami-consent-updated", handler);
  }, []);

  return null;
}
